<template>
  <div class="function-page">
    <!-- 区服选择区域 -->
    <div class="server-select-area">
      <span>请选择区服：</span>
      <select v-model="selectedServer" class="server-select">
        <option value="">--请选择区服--</option>
        <option v-for="server in serverNameList" :key="server" :value="server">
          {{ server }}
        </option>
      </select>
    </div>

    <!-- 功能按钮组 -->
    <div class="btn-group">
      <button
        v-if="hasPerm('recharge')"
        class="func-btn"
        :class="{ active: route.name === 'Recharge' }"
        @click="goPage('Recharge')"
      >
        充值返利
      </button>
      <button
        v-if="hasPerm('anchor')"
        class="func-btn"
        :class="{ active: route.name === 'Anchor' }"
        @click="goPage('Anchor')"
      >
        主播管理
      </button>
      <button
        v-if="hasPerm('pray')"
        class="func-btn"
        :class="{ active: route.name === 'Pray' }"
        @click="goPage('Pray')"
      >
        祈福控制
      </button>
      <button
        v-if="hasPerm('activity')"
        class="func-btn"
        :class="{ active: route.name === 'Activity' }"
        @click="goPage('Activity')"
      >
        限时活动管理
      </button>
      <button
        v-if="hasPerm('noticemanage')"
        class="func-btn"
        :class="{ active: route.name === 'NoticeManage' }"
        @click="goPage('NoticeManage')"
      >
        游戏公告
      </button>
      <button
        v-if="hasPerm('world')"
        class="func-btn"
        :class="{ active: route.path === '/world' }"
        @click="goWorldPage"
      >
        服务器窗口
      </button>
      <button
        v-if="hasPerm('adminuser')"
        class="func-btn"
        :class="{ active: route.name === 'AdminUser' }"
        @click="goPage('AdminUser')"
      >
        管理员账号管理
      </button>
      <button
        v-if="hasPerm('avatarstat')"
        class="func-btn"
        :class="{ active: route.name === 'AvatarStat' }"
        @click="goPage('AvatarStat')"
      >
        头像使用统计
      </button>
    </div>

    <!-- 子页面路由容器 -->
    <div class="page-content">
      <router-view />
    </div>
  </div>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router'
import { ref, onMounted } from 'vue'
import axios from 'axios'

const route = useRoute()
const router = useRouter()

// 区服列表
const serverNameList = ref([])
const selectedServer = ref('')
// 权限数组
const permList = ref([])

// 权限判断函数
const hasPerm = (permKey) => {
  return permList.value.includes(permKey)
}

// 页面初始化
onMounted(() => {
  // 读取本地权限
  const permStr = sessionStorage.getItem('adminPerms')
  if (!permStr) {
    // 没有登录凭证，退回登录页
    router.push('/login')
    return
  }
  try {
    permList.value = JSON.parse(permStr)
  } catch {
    sessionStorage.removeItem('adminPerms')
    router.push('/login')
    return
  }

  loadServerList()
})

// 获取区服名称列表
const loadServerList = async () => {
  try {
    const token = sessionStorage.getItem('token')
    const res = await axios.get('https://log.wuxiahaojie.com/api/FUWUQI/GetServerNameList', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    if (Array.isArray(res.data)) {
      serverNameList.value = res.data
    } else if (res.data.Data) {
      serverNameList.value = res.data.Data
    }
  } catch (err) {
    console.error('获取区服列表失败', err)
  }
}

const goPage = (name) => {
  router.push({ name })
}

const goWorldPage = () => {
  if (!selectedServer.value) {
    alert('请先选择区服！')
    return
  }
  router.push({
    path: '/world',
    query: {
      serverName: selectedServer.value
    }
  })
}
</script>

<style scoped>
.function-page {
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
}

.server-select-area {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.btn-group {
  display: flex;
  gap: 15px;
  margin-bottom: 30px;
  flex-wrap: wrap;
}

.func-btn {
  padding: 12px 24px;
  font-size: 16px;
  border: none;
  border-radius: 8px;
  background: #f0f2f5;
  cursor: pointer;
  transition: all 0.3s;
}

.func-btn:hover {
  background: #e5e6eb;
}

.func-btn.active {
  background: #409eff;
  color: #fff;
}

.page-content {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  min-height: 400px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.server-select {
  padding: 8px 12px;
  font-size: 15px;
  border-radius: 6px;
  border: 1px solid #dcdfe6;
}
</style>
